import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", {
    class: "el-month-table",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMonthTableClick && _ctx.handleMonthTableClick(...args))),
    onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args)))
  }, [
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, key) => {
        return (_openBlock(), _createElementBlock("tr", { key: key }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, key_) => {
            return (_openBlock(), _createElementBlock("td", {
              key: key_,
              class: _normalizeClass(_ctx.getCellStyle(cell))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.t('Controls.DatePicker.Months.' + _ctx.months[cell.text])), 1)
              ])
            ], 2))
          }), 128))
        ]))
      }), 128))
    ])
  ], 32))
}